import { FONT } from "@/styles/common";
import { Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomCenter = styled(Center)`
    color: ${({ theme }) => theme.COLOR.white};
    height: 100%;
`;

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 40, 500)}
`;

export const CustomSubText = styled(Text)`
    ${FONT("notoSerif", 14, 300)}
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => theme.COLOR.text[300]};
    }
`;
